// Word/line metrics for a part's markdown.
// Parity: backend/domain/text-stats.ts holds the same logic (kept in sync).

export interface TextStats {
  words: number
  lines: number
}

export function textStats(markdown: string): TextStats {
  const words = markdown.match(/\S+/g)?.length ?? 0
  const lines = markdown === '' ? 0 : markdown.split('\n').length
  return { words, lines }
}
